'use strict';

module.exports = {
    getAdformTranslation: function (key) {
        let translations = window.jsAdformTranslations || {};

        return translations[key] || key;
    }
};
